function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Pie_Chart_254922",
  "data-name": "noun_Pie Chart_254922",
  transform: "translate(-16.516 -8.225)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_80",
  "data-name": "Group 80",
  transform: "translate(20.518 13.943)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M37.426,40.926a4.95,4.95,0,1,1,4.95-4.95A4.956,4.956,0,0,1,37.426,40.926Zm0-9.148a4.2,4.2,0,1,0,4.2,4.2A4.2,4.2,0,0,0,37.426,31.778Z",
  transform: "translate(-32.476 -31.026)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_81",
  "data-name": "Group 81",
  transform: "translate(20.518 13.943)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M37.426,36.352H32.852a.376.376,0,0,1,0-.752h4.2V31.4a.376.376,0,0,1,.752,0v4.574A.376.376,0,0,1,37.426,36.352Z",
  transform: "translate(-32.476 -31.026)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_82",
  "data-name": "Group 82",
  transform: "translate(29.448 12.581)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M69.715,28.854a1.629,1.629,0,1,1,1.629-1.629A1.63,1.63,0,0,1,69.715,28.854Zm0-2.5a.876.876,0,1,0,.876.876A.877.877,0,0,0,69.715,26.35Z",
  transform: "translate(-68.087 -25.597)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_83",
  "data-name": "Group 83",
  transform: "translate(27.951 23.863)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M64.392,75.137a2.277,2.277,0,1,1,2.277-2.277A2.28,2.28,0,0,1,64.392,75.137Zm0-3.8a1.525,1.525,0,1,0,1.525,1.525A1.526,1.526,0,0,0,64.392,71.335Z",
  transform: "translate(-62.115 -70.583)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_84",
  "data-name": "Group 84",
  transform: "translate(16.516 21.004)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M18.793,63.737A2.277,2.277,0,1,1,21.07,61.46,2.28,2.28,0,0,1,18.793,63.737Zm0-3.8a1.525,1.525,0,1,0,1.525,1.525A1.527,1.527,0,0,0,18.793,59.936Z",
  transform: "translate(-16.516 -59.183)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_85",
  "data-name": "Group 85",
  transform: "translate(19.729 8.225)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M30.956,11.482a1.629,1.629,0,1,1,1.629-1.629A1.631,1.631,0,0,1,30.956,11.482Zm0-2.5a.876.876,0,1,0,.876.876A.877.877,0,0,0,30.956,8.978Z",
  transform: "translate(-29.327 -8.225)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_86",
  "data-name": "Group 86",
  transform: "translate(27.587 22.35)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M62.269,67.125a.376.376,0,0,1-.312-.166l-1.227-1.821a.376.376,0,0,1,.624-.421l1.227,1.821a.376.376,0,0,1-.312.587Z",
  transform: "translate(-60.665 -64.552)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_87",
  "data-name": "Group 87",
  transform: "translate(28.552 14.652)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M64.889,35.48a.376.376,0,0,1-.221-.681l1.2-.873a.376.376,0,0,1,.442.609l-1.2.873A.376.376,0,0,1,64.889,35.48Z",
  transform: "translate(-64.513 -33.854)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_88",
  "data-name": "Group 88",
  transform: "translate(21.477 10.628)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M38.48,22.248a.376.376,0,0,1-.338-.211L36.336,18.35a.376.376,0,1,1,.676-.331l1.806,3.687a.376.376,0,0,1-.338.542Z",
  transform: "translate(-36.297 -17.808)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_89",
  "data-name": "Group 89",
  transform: "translate(20.132 20.804)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M31.313,59.91a.376.376,0,0,1-.236-.669l.957-.772a.376.376,0,0,1,.472.586l-.957.772A.374.374,0,0,1,31.313,59.91Z",
  transform: "translate(-30.937 -58.386)",
  fill: "#222"
})));

var SvgGraphSvg = function SvgGraphSvg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.19,
    height: 20.192,
    viewBox: "0 0 16.19 20.192",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraphSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graphSvg.ee319d2c.svg";
export { ForwardRef as ReactComponent };